import React from "react";
import PageHero from "@/components/PageHero";
import PageMeta from "@/components/PageMeta";
import LeadForm from "@/components/LeadForm";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { BRAND } from "@/data/brand";

export default function Contact() {
  return (
    <div>
      <PageMeta
        title="Contact PSHL8"
        description="Sponsor, franchise investor, player, academy, media — tell us your interest and our team will respond within 24 hours."
        image="/api/og/contact/og-image.png"
      />
      <PageHero
        overline="Get in Touch"
        title={<>Contact <span className="text-pshl-electric">PSHL8.</span></>}
        subtitle="Sponsor, franchise investor, player, academy, media — tell us your interest and our team will respond within 24 hours."
        bgImage="https://images.pexels.com/photos/35280848/pexels-photo-35280848.jpeg"
      />

      <section className="section pt-0">
        <div className="pshl-container grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5 space-y-4">
            <a href={`mailto:${BRAND.email}`} className="block bg-pshl-surface border border-white/10 hover:border-pshl-electric transition-colors p-6">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 grid place-items-center bg-pshl-electric/15 border border-pshl-electric/40"><Mail className="h-5 w-5 text-pshl-electric" /></div>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.25em] text-white/55">Email</div>
                  <div className="font-display text-xl text-white">{BRAND.email}</div>
                </div>
              </div>
            </a>
            <a href={`tel:${BRAND.phone}`} className="block bg-pshl-surface border border-white/10 hover:border-pshl-electric transition-colors p-6">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 grid place-items-center bg-pshl-electric/15 border border-pshl-electric/40"><Phone className="h-5 w-5 text-pshl-electric" /></div>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.25em] text-white/55">Phone</div>
                  <div className="font-display text-xl text-white">{BRAND.phone}</div>
                </div>
              </div>
            </a>
            <a href={BRAND.whatsapp} target="_blank" rel="noreferrer" data-testid="contact-whatsapp" className="block bg-pshl-surface border border-white/10 hover:border-pshl-electric transition-colors p-6">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 grid place-items-center bg-pshl-electric/15 border border-pshl-electric/40"><MessageCircle className="h-5 w-5 text-pshl-electric" /></div>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.25em] text-white/55">WhatsApp</div>
                  <div className="font-display text-xl text-white">Chat with PSHL</div>
                </div>
              </div>
            </a>
            <div className="bg-pshl-surface border border-white/10 p-6">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 grid place-items-center bg-pshl-electric/15 border border-pshl-electric/40"><MapPin className="h-5 w-5 text-pshl-electric" /></div>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.25em] text-white/55">Headquarters</div>
                  <div className="font-display text-xl text-white">Gurugram, India</div>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:col-span-7"><LeadForm defaultInterest="general" title="Tell Us Your Interest" subtitle="Sponsor • Franchise • Player • Academy • Media" /></div>
        </div>
      </section>
    </div>
  );
}
